import { render, staticRenderFns } from "./DashboardFiilterModal.vue?vue&type=template&id=6f8e56a4"
import script from "./DashboardFiilterModal.vue?vue&type=script&lang=js"
export * from "./DashboardFiilterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports